interface TruckFillProps {
  quantity: number;
  truckload: number;
  unitLabel: string;
}

const BED_LENGTH = 232;

export function TruckFill({ quantity, truckload, unitLabel }: TruckFillProps) {
  const vans = quantity / truckload;
  const fill = Math.min(1, vans);
  const fillWidth = Math.max(0, Math.min(BED_LENGTH - 4, BED_LENGTH * fill));
  const columns = Math.max(0, Math.floor((fillWidth - 12) / 15));
  const caption =
    vans > 1 ? `${vans.toFixed(1)} vans` : `${Math.round(fill * 100)}% of a van`;
  return (
    <div className="relative h-28">
      <span className="absolute right-2 top-1.5 tabular-nums text-xs font-semibold text-chrome-muted">
        {caption}
      </span>
      <svg viewBox="0 0 340 118" className="h-full w-full" role="img" aria-label={`${caption}, ${truckload} ${unitLabel} per 53 foot dry van`}>
        <rect x="8" y="26" width={BED_LENGTH} height="58" rx="3" fill="var(--chrome-2)" stroke="var(--chrome-input)" />
        <rect x="10" y="28" width={fillWidth} height="54" fill="var(--chrome-3)" />
        {Array.from({ length: columns }, (_, index) => (
          <g key={index}>
            <rect x={14 + index * 15} y="34" width="12" height="20" rx="1.5" fill="#b08d5e" />
            <rect x={14 + index * 15} y="57" width="12" height="20" rx="1.5" fill="#c9a97a" />
          </g>
        ))}
        <text x="8" y="20" fontFamily="var(--font-sans)" fontSize="10" fill="var(--chrome-muted)">
          53&apos; van · {truckload.toLocaleString()} {unitLabel} flat
        </text>
        <path d="M244 84 V44 q0-8 8-8 h34 q10 0 14 10 l8 20 v18 z" fill="var(--chrome-3)" stroke="var(--chrome-input)" />
        <rect x="266" y="44" width="26" height="16" rx="2" fill="var(--chrome-input)" />
        <circle cx="60" cy="90" r="10" fill="var(--chrome-foreground)" stroke="var(--chrome-input)" />
        <circle cx="86" cy="90" r="10" fill="var(--chrome-foreground)" stroke="var(--chrome-input)" />
        <circle cx="290" cy="90" r="10" fill="var(--chrome-foreground)" stroke="var(--chrome-input)" />
        <line x1="4" y1="101" x2="336" y2="101" stroke="var(--chrome-border)" />
      </svg>
    </div>
  );
}
